import {
  Machine,
  RobotKinematics,
  RobotManufacturer,
  TeachIOMapping,
} from '../../robot.types';
import { AbstractManufacturerPlugin } from '../abstract-manufacturer.plugin';
import { URKinematics } from './ur-kinematics';
import { URModel } from './ur.types';

export class UniversalRobotsManufacturerPlugin extends AbstractManufacturerPlugin<URModel> {
  protected readonly MANUFACTURER = RobotManufacturer.UNIVERSAL_ROBOTS;
  protected readonly MANUFACTURER_DISPLAY_NAME = 'Universal Robots';
  protected readonly MODELS = Object.values(URModel);

  public getManufacturer(): RobotManufacturer {
    return this.MANUFACTURER;
  }

  public getManufacturerDisplayName(): string {
    return this.MANUFACTURER_DISPLAY_NAME;
  }

  public getModels(): URModel[] {
    return this.MODELS;
  }

  public getKinematics(modelNumber?: string | null): RobotKinematics {
    let model = URModel.UR10;

    if (modelNumber) {
      model = this.getModelByNumber(modelNumber) ?? model;
    }

    return new URKinematics(model);
  }

  public getDefaultIOMapping(_machine: Machine): TeachIOMapping {
    return {
      input: {
        capture: 'TOOL_1',
      },
      output: {
        light: 'TOOL_1',
      },
    };
  }
}
